import hammerjs from 'hammerjs';
import { enhancePointerEventInput, enhanceMouseInput } from './hammer-overrides';
enhancePointerEventInput(hammerjs.PointerEventInput);
enhanceMouseInput(hammerjs.MouseInput);
export var Manager = hammerjs.Manager;
export default hammerjs;
//# sourceMappingURL=hammer.browser.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/mjolnir.js/dist/esm/utils/hammer.browser.js
// module id = 360
// module chunks = 0